import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

import { clearUploadError } from "../../../../reducers/admin/integrationSlice";

import { CommonDialog, CommonDialogContent, CommonDialogTitle } from "../../../common/dialogs";
import { CommonDialogActions } from "../../../common/dialogs/common-dialog.jsx";
import { Button } from "../../../common/buttons";
import FileUploadField from "../../../common/form-controls/file-upload-input.jsx";

import "./style.less";

const ManualIntegrationDialog = ({ system, onClose, onApply, open, ...props }) => {
    const intl = useIntl();
    const dispatch = useDispatch();

    const innerTitle = intl.formatMessage({ id: "integration-page.manual-integration-dialog.title" }, { system });

    const uploadErrors = useSelector((state) => state.admin.integration.uploadErrors);

    const [roleFile, setRoleFile] = useState();
    const [employeeFile, setEmployeeFile] = useState();
    const [employeeRoleFile, setEmployeeRoleFile] = useState();

    const onSubmit = async () => {
        const formData = new FormData();
        formData.append("role", roleFile);
        formData.append("employee", employeeFile);
        formData.append("employee_role", employeeRoleFile);
        onApply(formData);
    };

    const cancelTitle = intl.formatMessage({ id: "common.btn-cancel" });
    const changeTitle = intl.formatMessage({ id: "common.btn-apply" });

    useEffect(() => {
        return () => {
            setRoleFile(null);
            setEmployeeFile(null);
            setEmployeeRoleFile(null);
        };
    }, []);

    const onCancel = () => {
        onClose();
    };

    return (
        <CommonDialog className="integration-schedule-dialog" open={!!open} {...props}>
            <CommonDialogTitle title={innerTitle} onClose={onCancel} />

            <CommonDialogContent>
                <Box className="integration-upload-function-step-form">
                    <FileUploadField
                        title={intl.formatMessage({ id: "integration-page.manual-integration-dialog.field.role" })}
                        id="role"
                        file={roleFile}
                        setFile={(file) => {
                            setRoleFile(file);
                            dispatch(clearUploadError("role"));
                        }}
                        errorMessage={uploadErrors && uploadErrors["role"] && uploadErrors["role"]["message"]}
                        error={uploadErrors && uploadErrors["role"]}
                    />

                    <FileUploadField
                        title={intl.formatMessage({ id: "integration-page.manual-integration-dialog.field.employee" })}
                        id="employee"
                        file={employeeFile}
                        setFile={(file) => {
                            setEmployeeFile(file);
                            dispatch(clearUploadError("employee"));
                        }}
                        errorMessage={uploadErrors && uploadErrors["employee"] && uploadErrors["employee"]["message"]}
                        error={uploadErrors && uploadErrors["employee"]}
                    />

                    <FileUploadField
                        title={intl.formatMessage({ id: "integration-page.manual-integration-dialog.field.employee-role" })}
                        id="employee_role"
                        file={employeeRoleFile}
                        setFile={(file) => {
                            setEmployeeRoleFile(file);
                            dispatch(clearUploadError("employee_role"));
                        }}
                        errorMessage={uploadErrors && uploadErrors["employee_role"] && uploadErrors["employee_role"]["message"]}
                        error={uploadErrors && uploadErrors["employee_role"]}
                    />
                </Box>
            </CommonDialogContent>

            <CommonDialogActions>
                <Button
                    variant="outlined"
                    onClick={onCancel}
                    sx={{
                        color: "var(--font-4)",
                        borderColor: "var(--font-4)",
                    }}
                >
                    {cancelTitle}
                </Button>

                <Button
                    variant="contained"
                    onClick={onSubmit}
                    sx={{
                        color: "var(--bg-2)",
                        backgroundColor: "var(--font-2)",
                        "&:hover": {
                            backgroundColor: "var(--font-2)",
                        },
                    }}
                >
                    {changeTitle}
                </Button>
            </CommonDialogActions>
        </CommonDialog>
    );
};

ManualIntegrationDialog.propTypes = {
    system: PropTypes.string,
    onClose: PropTypes.func,
    onApply: PropTypes.func,
    open: PropTypes.bool,
};

export default ManualIntegrationDialog;
